import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";
import { LabelWithDetail } from "./LabelWithDetail";

interface InviteLinkListCardProps {
  resources: Array<{ name: string; status?: string }>;
}

export const InviteLinkListCard = ({ resources }: InviteLinkListCardProps) => {
  const getStatusLabel = (status?: string) => {
    if (!status) return null;
    const statusKey = status === "inactive" ? "disabled" : status;
    const translationKey = `help_widget.copilot.chat_card.invite_link_statuses.${statusKey}`;
    const translated = t(translationKey);

    return translated === translationKey ? statusKey : translated;
  };

  return (
    <ListingCard
      title={t("help_widget.copilot.chat_card.invitation_links")}
      resources={resources}
      emptyStateText={t("help_widget.copilot.chat_card.no_links_found")}
      renderItem={link => (
        <LabelWithDetail
          label={link.name}
          detail={getStatusLabel(link.status)}
        />
      )}
      getItemKey={link => link.name}
    />
  );
};
